import { useState, useEffect } from 'react';

/**
 * Dynamically load the google-libphonenumber library and initialize a PhoneNumberUtil instance.
 * @returns {useGoogleLibPhoneNumberReturnValue}
 */
const useGoogleLibPhoneNumber = () => {
  const [GoogleLibPhoneNumber, setGoogleLibPhoneNumber] = useState(null);
  const [phoneUtil, setPhoneUtil] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const loadGoogleLibPhoneNumber = async () => {
      try {
        setLoading(true);
        const module = await import('google-libphonenumber');
        setGoogleLibPhoneNumber(module);
        setPhoneUtil(module.PhoneNumberUtil.getInstance());
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to load google-libphonenumber', err);
      } finally {
        setLoading(false);
      }
    };
    loadGoogleLibPhoneNumber();
  }, []);
  return {
    GoogleLibPhoneNumber,
    phoneUtil,
    loading
  };
};
export default useGoogleLibPhoneNumber;

/**
 * @typedef useGoogleLibPhoneNumberReturnValue
 * @type {object}
 * @property {import('google-libphonenumber')} GoogleLibPhoneNumber
 * @property {import('google-libphonenumber').PhoneNumberUtil} phoneUtil
 * @property {boolean} loading
 */